module.exports = __webpack_public_path__ + "img/select-group-title.5a92966e.png";